export default __webpack_public_path__ + "static/media/featured3.b0b9fb32.jpg";